module.exports = __webpack_public_path__ + "img/theme12.96a217e5.png";